import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { ReplaySubject, Subject } from 'rxjs';
import { debounceTime, delay, filter, map, takeUntil, tap } from 'rxjs/operators';
import { ReportUser, User } from '../../models/user'
import { ReportService } from '../../service/report.service'



@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit,OnDestroy {

  reportForm !: UntypedFormGroup;
  submitted = false;
  httpHeaders: any;
  dateRangeStart: any;
  dateRangeEnd: any;
  facilitatorId : number=0;
  meetingCnt! : number;
  isMeetingCnt : boolean = false;
  meetingStatus: string = "";
  status:string="";

  meetingstatus = [
    {value: 'Com', viewValue: 'Completed'},
    {value: 'NH', viewValue: 'Not Held'},
    {value: 'A', viewValue: 'Approved'},
    {value: 'YS', viewValue: 'Yet to Schedule'}
  ];


  /** list of users */
  protected users!: any[];

  /** control for the selected user for server side filtering */
  public userServerSideCtrl: UntypedFormControl = new UntypedFormControl();

   /** control for filter for server side. */
   public userServerSideFilteringCtrl: UntypedFormControl = new UntypedFormControl();

    /** indicate search operation is in progress */
    public searching: boolean = false;

    /** list of banks filtered after simulating server side search */
  public filteredServerSideUsers: ReplaySubject<ReportUser[]> = new ReplaySubject<ReportUser[]>(1);

  /** Subject that emits when the component has been destroyed. */
  protected _onDestroy = new Subject<void>();


  constructor(private http: HttpClient, private formBuilder: UntypedFormBuilder, private reportService:ReportService) {
    this.loadUsers();
  }
  
  loadUsers(){
      return new Promise(async (resolve, reject) => {
        await this.reportService.loadUsers().subscribe(userList => {
     
          if (userList!= null && userList != undefined) {
             this.users = userList;
             
            resolve(this.users);
          }
        });
       
      });
  }

  ngOnInit(): void {
    this.reportForm = this.formBuilder.group({
      daterange: ['']
    });

   /* this.userServerSideFilteringCtrl.valueChanges
     .pipe(()=> { return new User}).subscribe((filteredUsers) => {
      this.filteredServerSideUsers.next(filteredUsers);
      });*/
     // listen for search field value changes
     this.userServerSideFilteringCtrl.valueChanges
     .pipe(
       filter((search) => !!search),
       tap(() => (this.searching = true)),
       takeUntil(this._onDestroy),
       debounceTime(200),
       map((search) => {
         if (!this.users) {
           return [];
         }

         // simulate server fetching and filtering data
         return this.users.filter(
          (user) => user.user_fullname.toLowerCase().indexOf(search.toLowerCase()) > -1
         );
       }),
       delay(500)
      
     )
     .subscribe(
       (filteredUsers) => {
   
         this.searching = false;
    
         this.filteredServerSideUsers.next(filteredUsers);
       },
       (error) => {
         // no errors in our simulated example
         this.searching = false;
         // handle error...
       }
     );

  }


  dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
    this.dateRangeEnd = dateRangeEnd.value;
    this.dateRangeStart = dateRangeStart.value;
  }

  change(event:any)
  {
    if(event.source.selected) {
 
      this.meetingStatus = this.meetingStatus+';'+event.source.value
    }
  }

  download() {
    if (this.reportForm.invalid) {
      this.submitted = false;
      return;
    }
    if(this.userServerSideCtrl.value!=undefined && this.userServerSideCtrl.value?.pk_userid!=undefined){
      this.facilitatorId = this.userServerSideCtrl.value?.pk_userid;
    }
    
    this.reportService.downloadReport( this.dateRangeStart,this.dateRangeEnd, this.facilitatorId,this.meetingStatus)
    .subscribe((data: any) => {
      //this.meetingStatus = "";
 
      const blob = new Blob([data], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      //window.open(url);

      var a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.download = 'report_'+new Date().getFullYear()+'-'+new Date().getMonth()+'-'+new Date().getDay()+'-'+new Date().getHours()+'-'+new Date().getMinutes()+'-'+new Date().getSeconds()+'.xlsx';
      document.body.appendChild(a);
      a.click();

    });
  }

  getMeetingCount(){
    if (this.reportForm.invalid) {
      this.submitted = false;
      return;
    }
    if(this.userServerSideCtrl.value!=undefined && this.userServerSideCtrl.value?.pk_userid!=undefined){
      this.facilitatorId = this.userServerSideCtrl.value?.pk_userid;
    }
 
    this.reportService.getMeetingCount(this.dateRangeStart,this.dateRangeEnd, this.facilitatorId,this.meetingStatus).subscribe(meetingCnt => {
 
      //this.meetingStatus = "";
      this.isMeetingCnt = true;
      this.meetingCnt = Number(meetingCnt);
    });
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

}
